import { render, staticRenderFns } from "./CreditsHistoryDialog.vue?vue&type=template&id=7b56aef9&scoped=true"
import script from "./CreditsHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CreditsHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CreditsHistoryDialog.vue?vue&type=style&index=0&id=7b56aef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56aef9",
  null
  
)

export default component.exports